// Pagination Configuration
// This file centralizes all pagination-related configuration to avoid hard-coded values

export const PAGINATION_CONFIG = {
    // Default page sizes for different contexts
    DEFAULT_PAGE_SIZES: {
        SEARCH_RESULTS: 20,
        TAG_CLOUD: 50,
        ASSET_LIST: 25,
        USER_LIST: 15
    },
    
    // Available page size options for user selection
    AVAILABLE_PAGE_SIZES: [10, 20, 30, 50, 100],
    
    // Maximum allowed page sizes to prevent performance issues
    MAX_PAGE_SIZES: {
        SEARCH_RESULTS: 1000,
        TAG_CLOUD: 500,
        ASSET_LIST: 500,
        USER_LIST: 200
    },
    
    // Default page index (0-based)
    DEFAULT_PAGE_INDEX: 0,
    
    // Pagination behavior settings
    BEHAVIOR: {
        // Whether to show page size selector by default
        SHOW_PAGE_SIZE_SELECTOR: true,
        
        // Whether to remember user's page size preference
        REMEMBER_USER_PREFERENCE: true,
        
        // Whether to auto-reset to first page when filters change
        RESET_TO_FIRST_PAGE_ON_FILTER_CHANGE: true,
        
        // Whether to show total count information
        SHOW_TOTAL_COUNT: true,
        
        // Whether to show current page information
        SHOW_CURRENT_PAGE: true
    },
    
    // UI settings
    UI: {
        // Maximum number of page numbers to show before using ellipsis
        MAX_VISIBLE_PAGE_NUMBERS: 7,
        
        // Whether to show first/last page buttons
        SHOW_FIRST_LAST_BUTTONS: false,
        
        // Whether to show page size selector in pagination component
        SHOW_PAGE_SIZE_IN_PAGINATION: true,
        
        // Whether to show results summary (e.g., "Showing 1-20 of 100 results")
        SHOW_RESULTS_SUMMARY: true
    }
};

// Helper function to get appropriate page size for a context
export function getDefaultPageSize(context: keyof typeof PAGINATION_CONFIG.DEFAULT_PAGE_SIZES): number {
    return PAGINATION_CONFIG.DEFAULT_PAGE_SIZES[context];
}

// Helper function to get available page sizes for a context
export function getAvailablePageSizes(context: keyof typeof PAGINATION_CONFIG.DEFAULT_PAGE_SIZES): number[] {
    const maxSize = PAGINATION_CONFIG.MAX_PAGE_SIZES[context];
    return PAGINATION_CONFIG.AVAILABLE_PAGE_SIZES.filter(size => size <= maxSize);
}

// Helper function to validate page size for a context
export function isValidPageSize(size: number, context: keyof typeof PAGINATION_CONFIG.MAX_PAGE_SIZES): boolean {
    return size > 0 && size <= PAGINATION_CONFIG.MAX_PAGE_SIZES[context];
}

// Helper function to get default pagination parameters for a context
export function getDefaultPaginationParams(context: keyof typeof PAGINATION_CONFIG.DEFAULT_PAGE_SIZES) {
    return {
        pageIndex: PAGINATION_CONFIG.DEFAULT_PAGE_INDEX,
        itemsPerPage: getDefaultPageSize(context)
    };
}

